export default __webpack_public_path__ + "static/media/cam-upper.7b81c0dc.svg";